module.exports = __webpack_public_path__ + "img/mirror23.63629baf.jpg";